import { useState } from 'react';
import { useAppHookContext } from '@nkr/utils/rest-api/useAppHookContext';
import { IBaseResponse } from '@nkr/models/index';
import { AuthActionCreators } from '@nkr/store/index';

interface IRetVal {
    loading: boolean,
    error: string,
    requestTransfer: (medicalRecordId: number, currentCenterId: number, newCenterId: number) => Promise<IBaseResponse>,
    approveTransfer: (transferId: number) => Promise<IBaseResponse>
    declineTransfer: (transferId: number) => Promise<IBaseResponse>
}

const useTransferPatient = (): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const requestTransfer = async (medicalRecordId: number, currentCenterId: number, newCenterId: number) => {
        setLoading(true);

        const config = {
            url: `${__API__}/recipient/patient-intake/request-transfer`,
            data: {
                medicalRecordId,
                currentCenterId,
                newCenterId
            }
        };

        const response: IBaseResponse = await dispatch(AuthActionCreators.apiPost(config));

        if (response.data.success) {
            setError('');
        } else {
            setError(response.data.message);
        }

        setLoading(false);

        return response;
    };

    const approveTransfer = async (transferId: number) => {
        setLoading(true);

        const config = {
            url: `${__API__}/recipient/patient-intake/transfer/${transferId}/approve`,
        };

        const response: IBaseResponse = await dispatch(AuthActionCreators.apiPost(config));

        if (response.data.success) {
            setError('');
        } else {
            setError(response.data.message);
        }

        setLoading(false);

        return response;
    }

    const declineTransfer = async (transferId: number) => {
        setLoading(true);

        const config = {
            url: `${__API__}/recipient/patient-intake/transfer/${transferId}/decline`,
        };

        const response: IBaseResponse = await dispatch(AuthActionCreators.apiPost(config));

        if (response.data.success) {
            setError('');
        } else {
            setError(response.data.message);
        }

        setLoading(false);

        return response;
    }

    return {
        loading, error, requestTransfer, approveTransfer, declineTransfer
    };
}

export default useTransferPatient;
